module.exports = __webpack_public_path__ + "media/images/brand/newsletter/mail_man_400-46c57cab5cf908217409bad00f6d30a3.png";